export const getAcceptedFile = file => {
	if (file === "images") {
		return {
			"image/*": []
		};
	} else if (file === "videos") {
		return {
			"video/*": [] // Accept all video types
		};
	} else if (file === "documents") {
		return {
			"application/pdf": [],
			"text/plain": [],
			"application/msword": [],
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
			"application/vnd.ms-excel": [],
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": []
		};
	} else if (file === "css") {
		return {
			"text/css": [".css"]
		};
	} else {
		return {
			"image/*": [],
			"video/*": [],
			"application/pdf": [],
			"text/plain": [],
			"application/msword": [],
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
			"application/vnd.ms-excel": [],
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": []
		};
	}
};
